/* friendlyId.js generate and parses friendly ids */
import slugify from 'slugify'

export function makeFid(seg1, seg2, seg3) {
    // TODO needs regex to "remove" characters, defaults to `undefined` remove vowels
    let input = seg1

    if (seg2 != '') { input += '-' + seg2 }
    if (seg3 != '') { input += '-' + seg3 }

    const output = slugify(input, {
        remove: undefined,
        lower: true,     
        strict: true,
        locale: 'en',
    })

    return output
}

export function parseFid(id) {
    console.log('TODO: create parseFid() method')
    return id
}
